import React from "react";
import { ClipLoader } from "react-spinners";
import { IoIosWarning } from "react-icons/io";
import { Icon } from "@iconify/react";
import { ArrowUpRight } from "lucide-react";

const InfoCard = ({
  title,
  value,
  icon,
  bgColor = "white",
  loading = false,
  error,
  tooltip,
  valueClassName = "",
  valueStyle = {},
  cardIcon: CardIcon,
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group flex min-h-[108px] w-full flex-col items-center rounded-xl border border-slate-200 bg-white px-5 text-left shadow-[0px_8px_32px_0px_rgba(51,37,174,0.08)] transition-all duration-200 hover:-translate-y-0.5 hover:border-primary/30 hover:shadow-[0px_12px_30px_rgba(51,37,174,0.12)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
      aria-label={`View ${title}`}
    >
      <div className="flex w-full items-center gap-2 pt-4">
        <p className="font-inter text-sm font-medium leading-[22px] text-[#8E95A9]">
          {title}
        </p>
         {tooltip &&
          <div className="group/tooltip relative cursor-help">
              <Icon
                icon="mdi:help-circle-outline"
                className="text-[#6B7280]"
                width={15}
                height={15}
              />
              <div className="absolute left-1/2 top-full z-20 mt-1 hidden min-w-[200px] -translate-x-1/2 break-words whitespace-normal rounded-md bg-black px-2 py-1 text-center text-sm text-white group-hover/tooltip:block">
                {tooltip}
              </div>
          </div>}
        <ArrowUpRight className="ml-auto h-4 w-4 text-slate-300 transition-colors group-hover:text-primary" aria-hidden="true" />
      </div>

      <div className="flex w-full flex-row items-center justify-between gap-3 pb-4 pt-1">
        <h2
          className={`min-w-0 flex-1 pr-2 text-[22px] sm:text-[24px] font-semibold text-secondary leading-[32px] sm:leading-[40px] ${valueClassName}`}
          style={valueStyle}
        >
          {loading ? 
            <ClipLoader color="#60a5fa" loading={loading} size={24} speedMultiplier={0.5}/>
            : error || !value ? 
            <IoIosWarning style={{ paddingTop: "0.2rem", color: "#D3D9DF" }} />
            :
            value
          }
        </h2>

        <span
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-primary transition-transform duration-200 group-hover:scale-105"
          style={{ backgroundColor: bgColor }}
          aria-hidden="true"
        >
          {CardIcon ? <CardIcon className="h-5 w-5" strokeWidth={2} /> : <img src={icon} alt="" className="h-6 w-6" />}
        </span>
      </div>
    </button>
  );
};

export default InfoCard;

// const InfoCardu= ({}) => {
//   return (
//     <div
//       className="flex flex-col items-center px-5 min-h-[80px] 2xl:h-[12vh] bg-white rounded-lg "
//       style={{
//         boxShadow: "0px 8px 32px 0px rgba(51, 37, 174, 0.08)",
//       }}
//     >
//       <div className="flex-grow w-full pt-4">
//         <p className="text-sm  text-[#8E95A9] font-inter leading-[22px] font-medium">
//           {title}
//         </p>
//       </div>

//       <div className="flex flex-row pb-4 w-full justify-between">
//         <h2 className="text-[24px]  font-semibold text-secondary leading-[40px] ">
//           {loading ? 
//             <ClipLoader color="#60a5fa" loading={loading} size={24} speedMultiplier={0.5}/>
//             : error ? 
//             <IoIosWarning style={{ paddingTop: "0.2rem", color: "#D3D9DF" }} />
//             :
//             value
//           }
//         </h2>
//         <div
//           className="flex items-center justify-center w-10 h-10  rounded-[12px]"
//           style={{ backgroundColor: bgColor }}
//         >
//           <img src={icon} alt={`${title} icon`} className="w-6 h-6 " />
//         </div>
//       </div>
//     </div>
//   );
// };
